import {combineReducers} from "redux"
import {createPivotTableReducer} from 'reducers/pivotTable'
import types from "actions/types"
import {get} from "lodash"

export const jobCardListViewPivotTableKey = 'productionContext.jobBoards.jobCardListView.pivotTable'

export const orderTypeId = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.orderTypeId', state)
    default:
      return state
  }
}
export const statusTypes = (state = [0, 1, 2], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.statusTypes', state)
    default:
      return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return (action.filters.hasOwnProperty('timeKey')) ? action.filters.timeKey : state
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const selectedDepartments = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.selectedDepartments', state)
    default:
      return state
  }
}

export const selectedWorkCentres = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.selectedWorkCentres', state)
    default:
      return state
  }
}

export const selectedRoles = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.selectedRoles', state)
    default:
      return state
  }
}

export const selectedContacts = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.selectedContacts', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}


export default combineReducers({
  pivotTable: createPivotTableReducer({
    key: jobCardListViewPivotTableKey,
    defaultSortColumn: 'created',
  }),
  targetEnd,
  targetStart,
  dateTypes,
  selectedWorkCentres,
  companies,
  statusTypes,
  orderTypeId,
  selectedDepartments,
  selectedRoles,
  selectedContacts,
  timeKey,
})
